import { AmortizationType } from './AmortizationType';

export const AmortizationTypeOptions = [
    {
        id: AmortizationType.Type30,
        name: '30 Years',
    },
    {
        id: AmortizationType.Type25,
        name: '25 Years',
    },
    {
        id: AmortizationType.Type20,
        name: '20 Years',
    },
    {
        id: AmortizationType.Type15,
        name: '15 Years',
    },
    {
        id: AmortizationType.TypeIO,
        name: 'Interest Only',
    },
];
